import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../lib/api';
import Input from '../components/Common/Input';
import Label from '../components/Common/Label';
import Button from '../components/Common/Button';
import loginBanner from '../../src/assets/images/loginBanner.png';
import headerLogo from '../assets/images/nexusLogo.png';
import headerLogoInverse from '../assets/images/GradientNEXUS_inverse.svg';
import ToastMessage from '../components/Common/ToastMessage';

const ForgotPassword = () => {
  const [form, setForm] = useState({ email: '' });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success',
  });
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = 'Enter a valid email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const res = await forgotPassword(form);
      if (res.status === 200) {
        showToast('Verification email sent successfully', 'success');
      } else if (res.status === 404) {
        showToast('Incorrect Email, kindly verify your email', 'failed');
      } else {
        showToast(res.message || 'Email verification failed. Please try again', 'failed');
      }
    } catch (err) {
      showToast('Network error. Please try again', 'failed');
    }
  };

  const handleNavigateLogin = () => {
    navigate('/login');
  }

  return (
    <>
      <div className="grow loginHolder !h-full w-full flex gap-10 bg-white landscape:h-auto md:landscape:h-full landscape:overflow-auto">
        <div className="flex w-full fixed top-0 bottom-0 z-[9999]">
          <div className="absolute top-6 left-10 lg:left-16 z-10 cursor-pointer" onClick={handleNavigateLogin}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#1E2A2C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className='dark:stroke-white'/>
            </svg>
          </div>
          <div className="loginFormSection basis-full md:basis-1/2 mx-auto min-[2200px]:basis:[440px] lg:basis-[440px] flex justify-center items-center !py-0 lg:p-16 p-10 bg-white dark:bg-darkThemeBg relative w-full">
            <div className="w-full">
              <div className='loginLogoHolder' data-testid="forgot-password-logo" onClick={handleNavigateLogin}>
                <img src={headerLogo} alt="Logo" className="mx-auto w-40 cursor-pointer block dark:hidden" />
                <img src={headerLogoInverse} alt="Logo" className="mx-auto w-40 cursor-pointer hidden dark:block" />
              </div>
              <form className="loginForm mt-12" onSubmit={handleSubmit}>
                <div className="space-y-5 sm:space-y-6">
                  <div className="emailSection gap-1 flex flex-col relative">
                    <div className="flex flex-col gap-1">
                      <Label
                        htmlFor="email"
                        className="emailLabel text-dark-grey dark:text-white font-normal text-base leading-5 tracking-[-0.24px]"
                      >
                        Email
                      </Label>
                      <Input
                        id="email"
                        name="email"
                        type="text"
                        data-testid="forgot-password-email-input"
                        placeholder="Enter Email"
                        onChange={handleChange}
                        className="text-lg leading-6 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey dark:text-white h-11 bg-white dark:darkThemeGradiantBg dark:border-none dark:placeholder:text-white/40 placeholder:text-dark-grey/40 font-medium tracking-[-0.408px] outline-none"
                      />
                    </div>
                    {errors.email && (
                      <p
                        className='text-critical text-sm leading-4 absolute -bottom-5'
                        data-testid="forgot-password-email-error"
                      >
                        {errors.email}
                      </p>
                    )}
                  </div>
                  <Button
                    type="submit"
                    data-testid="forgot-password-submit-button"
                    className="loginBtn w-full bg-theme hover:bg-theme/80 h-10 font-bold leading-5 text-base justify-center items-center rounded-md text-white text-center flex !mt-12 cursor-pointer px-y py-3">
                    Send Verification Email
                  </Button>
                  <div className="mt-6 sm:mt-8 hidden">
                    <p className="text-center text-white font-normal text-sm  leading-5 ">Don't
                      have an account yet?<br />Click here to <span className="font-bold underline text-white cursor-pointer"><button type="button" className="underline">register.</button></span></p>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="mediaColumn lg:flex grow hidden">
            <img src={loginBanner} alt='banner' className="h-full object-cover w-full" />
          </div>
        </div>
        <div className="closeIconHolder absolute left-10 md:right-14 md:left-auto top-6 cursor-pointer sm:landscape:right-14 hidden md:hidden">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M4.7475 20.1575C4.5575 20.1575 4.3675 20.0875 4.2175 19.9375C3.9275 19.6475 3.9275 19.1675 4.2175 18.8775L17.8775 4.2175C18.1675 3.9275 18.6475 3.9275 18.9375 4.2175C19.2275 4.5075 19.2275 4.9875 18.9375 5.2775L5.2775 19.9375C5.1375 20.0875 4.9375 20.1575 4.7475 20.1575Z"
              fill="#717375" stroke="#717375"></path>
            <path
              d="M18.4075 20.1575C18.2175 20.1575 18.0275 20.0875 17.8775 19.9375L4.2175 5.2775C3.9275 4.9875 3.9275 4.5075 4.2175 4.2175C4.5075 3.9275 4.9875 3.9275 5.2775 4.2175L18.9375 18.8775C19.2275 19.1675 19.2275 19.6475 18.9375 19.9375C18.7875 20.0875 18.5975 20.1575 18.4075 20.1575Z"
              fill="#717375" stroke="#717375"></path>
          </svg>
        </div>
      </div>
      <ToastMessage
        message={toast.message}
        type={toast.type}
        show={toast.show}
        onClose={() => setToast(prev => ({ ...prev, show: false }))}
      />
    </>
  );
};

export default ForgotPassword;